// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { BackOrderModel } from "@store/Framework/Types/ApiModels";

export interface SetSelectedBackOrderItemParameter {
    backOrderItem: BackOrderModel | null;
}

type HandlerType = Handler<SetSelectedBackOrderItemParameter>;

export const DispatchSetSelectedBackOrderItem: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/SetSelectedBackOrderItem",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetSelectedBackOrderItem];

const setSelectedBackOrderItem = createHandlerChainRunner(chain, "SetSelectedBackOrderItem");
export default setSelectedBackOrderItem;
